import styles from './styles';

import { DescriptionListDefault } from '@cobliteam/base-components';

import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';

import HintPopupWithLink from '../HintPopupWithLink';

interface IdleEngineBadgeProps {
  placement: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top';
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const IdleEngineCalibrationBadge = ({ placement }: IdleEngineBadgeProps) => {
  const link = 'https://suporte.cobli.co/calibracao-motor-ocioso';
  const hintText = (
    <>
      Os dados gerados no período de calibração
      <br />
      {'são descartados. Para saber mais, '}
    </>
  );

  return (
    <HintPopupWithLink link={link} hintText={hintText} placement={placement}>
      <span className={styles.idleEngineBadge}>
        <SettingsEthernetIcon />
        <DescriptionListDefault>período de calibração</DescriptionListDefault>
      </span>
    </HintPopupWithLink>
  );
};

export default IdleEngineCalibrationBadge;
